import { optionSubcategory_appearance } from './appearanceSubCategory.locstring.json';
import { ThemeOption } from 'owa-theme-option';
import { OptionSubCategory } from 'owa-options-core';
import { DarkModeOption } from 'owa-dark-mode-option';

let appearanceSubCategory: OptionSubCategory = {
    key: 'appAppearance',
    titleStringKey: optionSubcategory_appearance,
    options: [ThemeOption, DarkModeOption],
};

export default appearanceSubCategory;
